(function ($) {
  customerService1ColRowV1 = {
    formatter: $('.cs-1-col-row-v1')
  };

  Drupal.behaviors.customerService1ColRowV1 = {
    get: function (key) {
      return customerService1ColRowV1[key];
    },

    set: function (key, val) {
      customerService1ColRowV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function (i) {
        var thisFormatter = $(this);
      // code goes here
      });
    }
  };
})(jQuery);
